import { useHeyGenStore } from "../stores/heygenStore";
import { stopAllVisualizerMicStreams } from "../components/live-speech-stage/wavesurfer-visualizers/wavesurfer-visualizers";

export const forceStopAllMediaStreams = (
  audioStreamRef: React.MutableRefObject<MediaStream | null>,
  wavRecorderRef?: React.MutableRefObject<any> | null
): void => {
  const streams: MediaStream[] = [];
  if (audioStreamRef?.current) streams.push(audioStreamRef.current);
  const store = useHeyGenStore.getState().audioStream;
  if (store) streams.push(store);
  const win = (window as any).__heygenAudioRefStream__;
  if (win instanceof MediaStream) streams.push(win);
  const rec = wavRecorderRef?.current;
  if (rec?.stream instanceof MediaStream) streams.push(rec.stream);

  streams.forEach((s) => {
    s.getTracks().forEach((t) => {
      try { if (t.readyState !== "ended") { t.enabled = false; t.stop(); } } catch (_) {}
    });
  });
  stopAllVisualizerMicStreams();
  audioStreamRef.current = null;
  useHeyGenStore.getState().setAudioStream(null);
  (window as any).__heygenAudioRefStream__ = null;
};
